<div>

  <mat-form-field actions appearance="outline" [formGroup]="form" style="margin-top: 1rem;">
    <mat-label>Search</mat-label>
    <input matInput type="text" formControlName="search">
    <button matSuffix mat-icon-button [disabled]="form.invalid" (click)="clearSearch()">
      <mat-icon *ngIf="form.invalid">search</mat-icon>
      <mat-icon *ngIf="form.valid">close</mat-icon>
    </button>
  </mat-form-field>

  <lib-container title="Users" style="width: 100%">

    <div actions style="width: 120px">
      <lib-button (click)="showUsersModal()">Add User</lib-button>
    </div>

    <div>
      <lib-content-loader *ngIf="loading"></lib-content-loader>

      <table *ngIf="users.length > 0 && !loading" mat-table [dataSource]="users">
        <ng-container matColumnDef="org">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">Org</th>
          <td mat-cell *matCellDef="let ref" style="width: 20%;">{{ ref.name }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">Name</th>
          <td mat-cell *matCellDef="let ref" style="width: 20%;">{{ ref.first_name + ' ' + ref.last_name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">Email</th>
          <td mat-cell *matCellDef="let ref" style="width: 20%;">{{ ref.email_address }}</td>
        </ng-container>

        <ng-container matColumnDef="workplace">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">Workplace</th>
          <td mat-cell *matCellDef="let ref" style="width: 20%;">{{ ref.workplace }}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">Role</th>
          <td mat-cell *matCellDef="let ref" style="width: 20%;">{{ ref.roleName }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;">Status</th>
          <td mat-cell *matCellDef="let ref" style="width: 10%;">{{ ref.active ? 'Active' : 'Inactive' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"></th>
          <td mat-cell *matCellDef="let ref" class="table-actions" style="width: 10%;">
            <lib-button mat-button color="accent" (click)="showUsersModal(ref)">
              Edit
            </lib-button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
      </table>

      <lib-content-loader *ngIf="loading"></lib-content-loader>

      <div *ngIf="users.length === 0 && !loading">
        <p>No current users found</p>
      </div>

    </div>

  </lib-container>